import { getEsbuildBuildEnvVar, getEsbuildRuntimeEnvVar } from '@loyalty/utils-angular/core';

const version = require('../../package.json').version as string; // eslint-disable-line

const getRuntimeEnvVar = (name: string) => getEsbuildRuntimeEnvVar(name, window) as string;
const getBuildEnvVar = (name: string) => getEsbuildBuildEnvVar(name, window) as string;

const platform = getRuntimeEnvVar('PLATFORM');
const production = platform !== 'local';
const apiDomain = getRuntimeEnvVar('API_DOMAIN');
const wizbiiDomain = getRuntimeEnvVar('WIZBII_DOMAIN');
const apiPlatform = getRuntimeEnvVar('API_PLATFORM');
const wizbiiTeamDomain = getRuntimeEnvVar('WIZBII_TEAM_ENV_FQDN');
const deployAssetsUrl = production
  ? `https://storage.googleapis.com/wizbii-application-assets/loyalty-admin-v3/${getBuildEnvVar('CI_COMMIT_SHA')}/fr/browser/assets`
  : null;

export const environment = {
  applicationId: 'loyalty-admin-v3',
  saasId: 'loyalty-app',
  platform,
  production,
  domain: wizbiiDomain,
  appUrl: window.location.host,
  cookieDomain: window.location.hostname === 'localhost' ? 'localhost' : wizbiiTeamDomain,
  api: {
    obendy: `https://obendy.api.${apiDomain}`,
    account: `https://account.api.${apiDomain}`,
    authentication: `https://auth.${apiDomain}`,
    customer: `https://customer-api.${apiDomain}`,
    place: `https://place.${apiDomain}`,
    domain: apiDomain,
    subscription: `https://subscription.api.${apiDomain}`,
    email: `https://email.api.${apiDomain}`,
    externalService: `https://loyalty-external-service-api.${apiDomain}/api`,
    file: `https://file.${apiDomain}`,
    googleStorage: `https://storage.googleapis.com`,
    platform: apiPlatform,
    profile: `https://customer-api.${apiDomain}/api/admin/loyalty-profile`,
    sso: `https://sso.internal.${wizbiiDomain}`,
  },
  urls: {
    admiin: `https://admiin.${wizbiiTeamDomain}`,
  },
  algolia: {
    clientName: 'obendy',
    index: {
      users: `${apiPlatform}_obendy_profile`,
      services: `${apiPlatform}_loyalty_service`,
      partners: `${apiPlatform}_loyalty_partner`,
    },
  },
  wizbiiFiles: getRuntimeEnvVar('FILE_API_BUCKET'),
  version,
  bugsnag: {
    apiKey: '16b75005a97e02c3a7f9848444e4c109',
  },
  deployAssetsUrl: window.location.hostname === 'localhost' ? `http://${window.location.host}/assets` : deployAssetsUrl,
  wip: '🚧',
} as const;
